import gql from 'graphql-tag';

export default gql`
  mutation finishEvent($eventId: ID!, $report: String!, $channelIds: [Int]!) {
    eventFinish(eventId: $eventId, report: $report, channelIds: $channelIds)
  }
`;
